import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import BrandLogo from './BrandLogo';
import { tokens } from '../theme';
import authBonsai from '../assets/auth-bonsai.png';

export default function AuthSplitLayout({
  title,
  subtitle,
  rightTitle,
  rightSubtitle,
  leftImage = authBonsai,
  leftImageMood = 'dark',
  footer,
  children,
}) {
  return (
    <Grid container sx={{ minHeight: '100vh', bgcolor: tokens.bg }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: { xs: 'none', md: 'flex' },
          position: 'relative',
          overflow: 'hidden',
          borderRight: `1px solid ${tokens.border}`,
          background:
            'radial-gradient(circle at 22% 16%, rgba(169, 191, 122, 0.12), transparent 30%), linear-gradient(135deg, #06100c 0%, #09140f 48%, #101c16 100%)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `linear-gradient(180deg, ${leftImageMood === 'bright' ? 'rgba(8,17,13,0.34) 0%, rgba(8,17,13,0.22) 30%, rgba(8,17,13,0.5) 100%' : 'rgba(6,16,12,0.18) 0%, rgba(6,16,12,0.34) 100%'}), url(${leftImage})`,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            opacity: 0.96,
            transform: 'scale(1.02)',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 'auto 0 0 0',
            height: leftImageMood === 'bright' ? '62%' : '48%',
            background:
              leftImageMood === 'bright'
                ? 'linear-gradient(180deg, transparent 0%, rgba(8,17,13,0.18) 18%, rgba(8,17,13,0.82) 100%)'
                : 'linear-gradient(180deg, transparent 0%, rgba(8,17,13,0.18) 16%, rgba(8,17,13,0.84) 100%)',
          }}
        />
        {leftImageMood === 'bright' ? (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(90deg, rgba(8,17,13,0.62) 0%, rgba(8,17,13,0.34) 34%, rgba(8,17,13,0.1) 64%, rgba(8,17,13,0.04) 100%)',
            }}
          />
        ) : null}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 18% 22%, rgba(255,255,255,0.04), transparent 22%), linear-gradient(90deg, rgba(255,255,255,0.02), transparent 26%)',
          }}
        />
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1, p: 6.5 }}>
          <BrandLogo subtle />
          <Box
            sx={{
              mt: 'auto',
              mb: 18,
              maxWidth: 410,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: '#f7efe3',
                fontSize: { md: '4.25rem', lg: '4.85rem' },
                lineHeight: 0.95,
                mb: 3.5,
                textShadow: leftImageMood === 'bright' ? '0 8px 22px rgba(0,0,0,0.22)' : '0 10px 28px rgba(0,0,0,0.28)',
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: leftImageMood === 'bright' ? 'rgba(243,236,223,0.82)' : 'rgba(243,236,223,0.88)',
                textShadow: leftImageMood === 'bright' ? '0 4px 14px rgba(0,0,0,0.16)' : '0 6px 18px rgba(0,0,0,0.2)',
                maxWidth: 340,
                fontSize: '1.03rem',
              }}
            >
              {subtitle}
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ mt: 'auto', color: 'rgba(243,236,223,0.45)' }}>
            © {new Date().getFullYear()} FastTime. All rights reserved.
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'center',
          background: 'linear-gradient(180deg, #f4edde 0%, #efe7d8 100%)',
          color: '#1f2b22',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 640,
            px: { xs: 3, sm: 6 },
            py: { xs: 4, md: 7 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '& .MuiInputBase-root': {
              color: '#1f2b22',
              backgroundColor: 'rgba(255,255,255,0.58)',
            },
            '& .MuiInputBase-input': {
              color: '#1f2b22',
              WebkitTextFillColor: '#1f2b22',
            },
            '& .MuiInputBase-input::placeholder': {
              color: 'rgba(31,43,34,0.5)',
              opacity: 1,
            },
            '& .MuiInputLabel-root': {
              color: 'rgba(31,43,34,0.58)',
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: '#5f7a52',
            },
            '& .MuiFormHelperText-root': {
              color: 'rgba(31,43,34,0.58)',
            },
            '& .MuiSvgIcon-root': {
              color: 'rgba(31,43,34,0.5)',
            },
            '& input:-webkit-autofill': {
              WebkitBoxShadow: '0 0 0 100px rgba(255,255,255,0.58) inset',
              WebkitTextFillColor: '#1f2b22',
              caretColor: '#1f2b22',
            },
          }}
        >
          <Box sx={{ display: { xs: 'flex', md: 'none' }, mb: 6 }}>
            <BrandLogo />
          </Box>
          <Box sx={{ mb: 5 }}>
            <Typography
              variant="h2"
              sx={{
                color: '#1f2b22',
                fontSize: { xs: '2.6rem', sm: '3.35rem' },
                mb: 1.25,
                textAlign: { md: 'left' },
              }}
            >
              {rightTitle}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(31,43,34,0.68)', fontSize: '1rem' }}>
              {rightSubtitle}
            </Typography>
          </Box>
          {children}
          {footer ? <Box sx={{ mt: 4 }}>{footer}</Box> : null}
        </Box>
      </Grid>
    </Grid>
  );
}
